import image from '../../../../static/admissions@large.jpg';

const key = 'admissions';

export default {
  rootNavKey: [key],
  parentKeys: [key],
  image,
};
